import history from '../../../history.js';
import cookie from 'react-cookies'
import {setDefaultSettings} from '../../../store/actions/fuse';
import {FuseDefaultSettings} from '../../../@fuse';
import _ from 'lodash';

const Action = {
    SET_USER_DATA: '[USER] SET DATA',
    REMOVE_USER_DATA: '[USER] REMOVE DATA',
    USER_LOGGED_OUT: '[USER] LOGGED OUT',
};

const ActionCreator = {
    setDefaultSettings: setDefaultSettings,
    setUserData(user, doNotUpdate) {
        return (dispatch) => {

            //!doNotUpdate && user.role !== 'guest' && ActionCreator.updateUserData(user);

            dispatch(setDefaultSettings(user.data.settings));

            dispatch({
                type: Action.SET_USER_DATA,
                payload: user
            })
        }
    },
    updateUserSettings(settings) {
        return (dispatch, getState) => {
            const user = _.merge({}, {data: {settings}});
            return dispatch(ActionCreator.setUserData(user));
        }
    },
    removeUserData() {
        return {
            type: Action.REMOVE_USER_DATA
        }
    },
    logoutUser() {
        history.push({
            pathname: '/'
        });

        return (dispatch) => {
            cookie.remove('apiToken', { path: '/' });

            dispatch(setDefaultSettings(FuseDefaultSettings));

            dispatch({type: Action.USER_LOGGED_OUT});
        }
    },
    updateUserData(user) {
        switch (user.from) {
            default: {

            }
        }
    },
};

const initialState = {
    role: 'guest',
    data: {
        'displayName': 'John Doe',
        'photoURL': 'assets/images/avatars/profile.jpg',
        'email': 'johndoe@withinpixels.com',
        shortcuts: [
            'calendar',
            'mail',
            'contacts',
            'analytics-dashboard'
        ]
    }
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.SET_USER_DATA: {
            return {
                ...state,
                ...action.payload
            };
        }
        case Action.REMOVE_USER_DATA: {
            return {
                ...initialState
            };
        }
        case Action.USER_LOGGED_OUT: {
            return initialState;
        }
        default: {
            return state
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/auth/user.js